import React from 'react';

import Loader from 'app/components/Loader';

import styles from './styles.css';

const Notice = ({ highlight, text, title }) => {
  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
        <h4 className={styles.title}>{title}</h4>
        <p className={styles.text}>{text}</p>
        <p className={styles.highlight}>{highlight}</p>
      </div>
    </div>
  );
};

export default Notice;



// WEBPACK FOOTER //
// ./src/components/Notice/index.js